import React from 'react';
import { Github } from 'lucide-react';

interface HeaderProps {
  glassStyle: string;
}

const Header: React.FC<HeaderProps> = ({ glassStyle }) => {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    console.error('Failed to load Tavily logo');
    console.log('Image path:', e.currentTarget.src);
    e.currentTarget.style.display = 'none';
  };

  return (
    <div className="relative mb-16">
      <div className="text-center pt-4">
        <h1 className="text-[48px] font-medium text-[#1a202c] font-['DM_Sans'] tracking-[-1px] leading-[52px] text-center mx-auto antialiased">
          Company Research Agent
        </h1>
        <p className="text-sm text-gray-500 mt-2 font-['DM_Sans']">
          Based on Tavily's open-source{' '}
          <a 
            href="https://github.com/guy-hartstein/company-research-agent" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#468BFF] hover:text-[#3470cc] underline"
          >
            Company Research Agent
          </a>
          {' '}• LLM served on{' '}
          <a 
            href="https://console.gmicloud.ai/?tab=maas" 
            target="_blank" 
            rel="noopener noreferrer"
            className="font-semibold text-[#468BFF] hover:text-[#3470cc] underline"
          >
            GMI Inference Engine
          </a>
        </p>
      </div>
      {/* External icons removed per request */}
    </div>
  );
};

export default Header; 